import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts"

const Chart = ({data, chartComponent}) => {
  require("highcharts/modules/exporting")(Highcharts);
  return (
    <>
      <HighchartsReact
        ref={chartComponent}
        highcharts={Highcharts}
        options={data}
      />
    </>
  );
};

export default Chart;

